module.exports = __webpack_public_path__ + "img/km.e8dcd6cb.svg";